/* @refresh reload */
import { MountableElement, render } from 'solid-js/web';
import { App } from './App';
import './modules/type-extensions';
render(() => <App />, document.getElementById('root') as MountableElement);